
import { combineReducers } from 'redux';
import dataCategory from './dataCategory';
import dataDetail from './dataDetail';
import resize from './resize';

const programme = combineReducers({
  dataCategory,
  dataDetail,
  resize,
});

export default programme;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js